import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#0074b8',
        secondary: '#00639c',
        black: '#000000',
        white: '#ffffff'
      }
    }
  }
})
